import { CHAT_HISTORY_QUERY_KEY } from "@frontend-shared/constants";

// NOTE: NSAI-5908 — the one builder of a chat-history query key. It lives in a
// leaf module because the stream buffer needs it too, and importing the
// history hook from there would close an import cycle through the API
// services and the websocket service.
export const chatHistoryQueryKey = (chatId: string): readonly string[] => [
  CHAT_HISTORY_QUERY_KEY,
  chatId,
];
